"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateByRestrictions = exports.hasNumberValue = exports.hasNotEmptyValue = exports.parseFormErrors = exports.pipeFieldErrors = exports.mergeFieldErrors = void 0;
const ValidationErrors_1 = require("../../components/ValidationErrors");
const object_1 = require("../../utils/object");
const roundMoney_1 = require("../../utils/roundMoney");
const mergeFieldErrors = (rawErrors) => {
    const errors = Array.isArray(rawErrors) ? rawErrors : [rawErrors];
    const result = errors.flat(Infinity).filter((x) => !!x);
    return result.length ? result : undefined;
};
exports.mergeFieldErrors = mergeFieldErrors;
/**
 * Pass validation by layers:\
 * 1) Descriptor
 * 2) Config
 * 3) Schema
 *
 * On each layer, validation can duplicate kind of error.\
 * This function to avoids triple error text "Field is required" .\
 * If a more primitive layer there is an error, then it is necessary to resolve a simpler error.\
 */
const pipeFieldErrors = (...rawErrors) => {
    const firstErrors = rawErrors.reduce((acc, x) => (0, exports.mergeFieldErrors)(acc !== null && acc !== void 0 ? acc : x), undefined);
    return (0, exports.mergeFieldErrors)(firstErrors);
};
exports.pipeFieldErrors = pipeFieldErrors;
/** Schema errors to component errors */
const parseFormErrors = (errors) => {
    if (!errors)
        return {};
    return (0, object_1.mapObject)(errors, ([key]) => ((0, ValidationErrors_1.getFormError)(errors, key)));
};
exports.parseFormErrors = parseFormErrors;
/** The user has not entered any input */
const hasNotEmptyValue = (value) => (![undefined, null, ''].includes(value));
exports.hasNotEmptyValue = hasNotEmptyValue;
const hasNumberValue = (value) => (!Number.isNaN(Number(value)));
exports.hasNumberValue = hasNumberValue;
const validateByRestrictions = (value, 
/** Validate on submit */
final, restrictions) => {
    if (!(0, exports.hasNotEmptyValue)(value)) {
        if (final && (restrictions === null || restrictions === void 0 ? void 0 : restrictions.required)) {
            return ValidationErrors_1.messageById['schema/required'].text(undefined);
        }
        return undefined;
    }
    if ((0, exports.hasNumberValue)(value)) {
        const validatePositive = () => {
            if (!(restrictions === null || restrictions === void 0 ? void 0 : restrictions.positiveNumber))
                return undefined;
            if (value >= 0)
                return undefined;
            return ValidationErrors_1.additionalMessageById.positiveNumber;
        };
        const validateZero = () => {
            if (!(restrictions === null || restrictions === void 0 ? void 0 : restrictions.withoutZeroNumber))
                return undefined;
            if (value !== 0)
                return undefined;
            return ValidationErrors_1.additionalMessageById.withoutZeroNumber;
        };
        const validateRounded = () => {
            if (!(restrictions === null || restrictions === void 0 ? void 0 : restrictions.roundedMoney))
                return undefined;
            if ((0, roundMoney_1.roundMoney)(value) === value)
                return undefined;
            return ValidationErrors_1.messageById['custom/rounded'].text(undefined);
        };
        const validateInteger = () => {
            if (!(restrictions === null || restrictions === void 0 ? void 0 : restrictions.integer))
                return undefined;
            if (Math.round(value) === value)
                return undefined;
            return ValidationErrors_1.additionalMessageById.integerNumber;
        };
        return (0, exports.mergeFieldErrors)([
            validatePositive(),
            validateZero(),
            validateRounded(),
            validateInteger(),
        ]);
    }
    return undefined;
};
exports.validateByRestrictions = validateByRestrictions;
//# sourceMappingURL=validation.js.map